var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'field',
    { 'field-success': _vm.success }
  ]},[_c('OLabel',[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"field__slot"},[_vm._t("default"),_c('div',{staticClass:"field__loader"},[(_vm.loading)?_c('OLoader'):_vm._e()],1)],2),_c('OErrors',{attrs:{"errors":_vm.errors}}),_c('div',{staticClass:"field__hint"},[_vm._v(" "+_vm._s(_vm.hint)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }